module.exports = __webpack_public_path__ + "img/logo_tencentcloud.ed4afacc.svg";